import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Marca } from '../interfaces/marca';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: "root",
})
export class MarcaService {
  readonly path = "/marca";

  constructor(
    private http: HttpClient,
    public jwtAuthService: JwtAuthService
  ) {}

  create(): Observable<Marca> {
    return this.http.post<Marca>(`${this.jwtAuthService.apiUrl + this.path}`,null);
  }

  saveOrUpdate(cadastro: Marca): Observable<Marca> {
    return this.http.put<Marca>(
      `${this.jwtAuthService.apiUrl + this.path}`,
      cadastro
    );
  }

  getMarca(id: number): Observable<Marca> {
    return this.http.get<Marca>(
      `${this.jwtAuthService.apiUrl + this.path}/${id}`
    );
  }

  getMarcaPage(
    page?: number,
    size?: number,
    order?: string,
    direction?: string
  ): Observable<PageResult<Marca>> {
    console.log(
      `${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
        `${size}&order=${order}&direction=${direction}`
    );
    return this.http.get<PageResult<Marca>>(
      `${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
        `${size}&order=${order}&direction=${direction}`
    );
  }

  getMarcaPageSearch(
    page?: number,
    size?: number,
    search?: string,
    order?: string,
    direction?: string
  ): Observable<PageResult<Marca>> {
    console.log(
      `${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
        `${size}&search=${search}&order=${order}&direction=${direction}`
    );
    console.log("search", search);
    return this.http.get<PageResult<Marca>>(
      `${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
        `${size}&search=${search}&order=${order}&direction=${direction}`
    );
  }

  doesCodeExist(code: any, uuid: string) {
    return this.http.get<boolean>(
      `${this.jwtAuthService.apiUrl + this.path}/${code}?uuid=${uuid}`
    );
  }
}
